import { render, staticRenderFns } from "./InitialQuiz.vue?vue&type=template&id=25f021c1&scoped=true&"
import script from "./InitialQuiz.vue?vue&type=script&lang=ts&"
export * from "./InitialQuiz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f021c1",
  null
  
)

export default component.exports